import { entitiesReducer } from '@/store/entities';

export const showLoader = (label) => (dispatch) => {
  dispatch(entitiesReducer.showLoader(label));
};

export const hideLoader = () => (dispatch) => {
  dispatch(entitiesReducer.hideLoader());
};

export const addToastInfo = (message) => (dispatch) => {
  dispatch(entitiesReducer.setToastInfo(message));
};
export const hideToastInfo = () => (dispatch) => {
  dispatch(entitiesReducer.setToastInfo(''));
};

export const addToastError = (message) => (dispatch) => {
  dispatch(entitiesReducer.setToastError(message));
};
export const hideToastError = () => (dispatch) => {
  dispatch(entitiesReducer.setToastError(''));
};

export const addToastSuccess = (message) => (dispatch) => {
  dispatch(entitiesReducer.setToastSuccess(message));
};
export const hideToastSuccess = () => (dispatch) => {
  dispatch(entitiesReducer.setToastSuccess(''));
};

export const setCountries = (countries) => (dispatch) => {
  dispatch(entitiesReducer.setCountries(countries));
};
export const setLanguages = (languages) => (dispatch) => {
  dispatch(entitiesReducer.setLanguages(languages));
};
